import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CouponView, CreateCouponPayload } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCoupons } from "@/lib/query/core/invalidation";

type CreateCouponInput = CreateCouponPayload & { storeSlug: string };

export function useCreateCouponMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeSlug: _storeSlug, ...body }: CreateCouponInput) =>
      apiJsonClient<CouponView>(endpoints.seller.coupons, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerCoupons(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
